import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { RequestDemo } from '../core/model/v2/healthSystem/request-demo';
import { HealthSystemService } from '../core/services/v2/health-system.service';
import { WindowLoaderService } from '../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-appypartnerscontactinfo',
  templateUrl: './appypartnerscontactinfo.component.html',
  styleUrls: ['./appypartnerscontactinfo.component.scss']
})
export class AppypartnerscontactinfoComponent implements OnInit {

  companyNameFormControl = new FormControl('', [Validators.required]);
  websiteFormControl = new FormControl('', []);
  titleFormControl = new FormControl('', [Validators.required]);
  contactNameFormControl = new FormControl('', [Validators.required]);
  phoneFormControl = new FormControl('', [Validators.required]);
  emailFormControl = new FormControl('', [Validators.required, Validators.email]);
  commentsFormControl = new FormControl('', [Validators.required]);

  contactForm = new FormGroup({
    companyName: this.companyNameFormControl,
    website: this.websiteFormControl,
    title: this.titleFormControl,
    contactName: this.contactNameFormControl,
    phone: this.phoneFormControl,
    email: this.emailFormControl,
    comments: this.commentsFormControl
  });

  constructor(private router: Router, private healthSystemService: HealthSystemService, private loaderService: WindowLoaderService) { }

  ngOnInit() {
  }

  sendContact() {
    if (this.contactForm.invalid) {
      return;
    }

    const request = this.buildRequestObject();

    this.loaderService.show();
    this.healthSystemService.requestDemo(request).subscribe(
      () => {
        sessionStorage.setItem('requestDemoText', 'true');
        this.router.navigate(["/EmailLink"]);
        this.loaderService.hide();
      },
      (error) => { console.error(error); this.loaderService.hide(); },
      () => { this.loaderService.hide(); }
    );
  }

  private buildRequestObject(): RequestDemo {

    const requestDemo = new RequestDemo();
    // requestDemo.npi = this.npiFormControl.value;
    requestDemo.npi = '';
    requestDemo.practiceName = this.companyNameFormControl.value;
    // requestDemo.website = this.websiteFormControl.value;
    requestDemo.title = this.titleFormControl.value;
    requestDemo.firstName = this.contactNameFormControl.value;
    requestDemo.lastName = this.contactNameFormControl.value;
    requestDemo.phoneNumber = this.phoneFormControl.value;
    requestDemo.emailAddress = this.emailFormControl.value;
    requestDemo.notes = this.commentsFormControl.value;

    return requestDemo;
  }

}
